import { axios } from "utils";

import { ADMIN_BEEF_URL as endpoint } from "consts";

import { BeefCowType, BeefFeedAdditive, BeefFeedType, BeefManureStorageType } from "models";

export const getBeefCowTypesAdmin = async ({ enabled }: { enabled?: boolean } = {}): Promise<BeefCowType[]> =>
  axios.get(`${endpoint}/beef-cow-types`, { params: { enabled } });

export const getBeefFeedAdditivesAdmin = async (): Promise<BeefFeedAdditive[]> => axios.get(`${endpoint}/beef-feed-additives`);

export const getBeefFeedTypesAdmin = async ({ enabled }: { enabled?: boolean } = {}): Promise<BeefFeedType[]> =>
  axios.get(`${endpoint}/beef-feed-types`, { params: { enabled } });

export const getBeefManureStorageTypesAdmin = async (): Promise<BeefManureStorageType[]> => axios.get(`${endpoint}/beef-manure-storage-types`);
